// extracted by mini-css-extract-plugin
export var completionBody = "_ka-2";
export var completionCard = "_ka-0";
export var completionFooter = "_ka-3";
export var completionTitle = "_ka-1";